<ul class="accordion">
    <!-- Mainmenu item -->
    @for (item of menuService.menuItems$ | async; track item) {
        <li [class.active]="item.active" [ngClass]="{ 'has-submenu': item.submenu }">
            <div class="menu flex-row mr-15px" (click)="onMenuClick(item)" [class.selected]="item.selected">
                <div class="flex flex-col align-middle mt-auto mr-20px ml-20px mb-auto">
                    @if (item.icon) {
                        <mat-icon [svgIcon]="item.selected || item.active ? item.selectedIcon : item.icon"></mat-icon>
                    }
                </div>
                <div class="flex-col flex-1" [translate]="item.title"></div>
                <div class="arrow flex-col align-middle mr-10px mt-auto mb-auto">
                    @if (item.submenu) {
                        <mat-icon svgIcon="evida_menu_arrow"></mat-icon>
                    }
                </div>
            </div>
            <!-- Submenu items -->
            @if (item.submenu) {
                <ul
                    #submenu
                    class="submenu"
                    [class.active]="submenu.selected"
                    [style.height.px]="item.selected ? item.calculatedHeight : 0"
                >
                    @for (submenu of item.submenu; track submenu) {
                        @if (!submenu.hidden) {
                            <li [class.selected]="submenu.selected">
                                <a
                                    class="mr-10px"
                                    [class.selected]="submenu.selected"
                                    (click)="onSubmenuClick(submenu)"
                                >
                                    <span class="ml-10 relative">
                                        <span class="flex-1" [translate]="submenu.title"></span>
                                        @if (shouldDisplayRequestCount(submenu)) {
                                            <span class="absolute notify-counter x-small text-center text-white">{{
                                                accessRequestCount
                                            }}</span>
                                        }
                                    </span>
                                </a>
                            </li>
                        }
                    }
                </ul>
            }
        </li>
    }

    <!-- Cancel gas supply button -->
    <span
        class="link flex body-header fg-green"
        [routerLink]="['/flow/readings']"
        translate="menu.cancelGasSupply"
    ></span>
</ul>
